module.exports = __webpack_public_path__ + "img/coinspopup-3.7688d47d.png";